<div fxLayout="column" fxFlexFill *ngIf="!loader && !success && !successYavin">

  <div class="p-4" fxLayoutAlign="start center" fxLayoutGap="10px">

    <button mat-icon-button (click)="goBack()" angulartics2On="click" angularticsAction="goPreviousPage"
      angularticsCategory="rechargeCard">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div fxLayout="column" *ngIf="currMerchant">
      <span class="mat-title">{{currMerchant.denomination | capitalize | descFilter: 20}}</span>
      <span class="mat-title boldest">{{"rechargeComponent.title" |translate }}</span>
    </div>

  </div>

  <div fxLayout="column" class="scrolled" fxFlex class="p-4">

    <!-- Amount -->
    <div fxLayout="row" fxLayoutAlign="space-between center" [ngClass]="cssService.cardClass" class="p-4">

      <div>
        <span class="mat-headline" ngClass.xs="mat-title">{{"rechargeComponent.info" |translate }}</span>
      </div>

      <div [ngClass]="{'animSucc' : successRecharge}" *ngIf="merchantClient$">
        <span class="mat-headline boldest" ngClass.xs="mat-title">{{(merchantClient$.credit_amount?merchantClient$.credit_amount:0) | priceFilter}}</span>
      </div>

    </div>

    <!-- Error or success message -->
    <mat-card fxLayout="row" fxLayoutAlign="center center" class="text-center"
      [ngClass]="{'warn' : errorMessage, 'great' : successMessage}" *ngIf="successMessage || errorMessage">
      <span class="mat-subheading-2">{{errorMessage ? errorMessage : successMessage}}</span>
    </mat-card>

    <!-- Form credit card -->
    <div fxLayout="column" *ngIf="!loader && merchantClient$ && merchantClient$.archive === 0"
      fxLayoutGap="20px">

      <!-- Montant -->
      <div fxLayout="column" fxLayoutGap="10px"  [ngClass]="cssService.cardClass" class="p-4 mt-4">

        <div>
          <span class="title-endorder-card">{{"client.refill.amount-to-credit" | translate | uppercase}}</span>
        </div>


        <div>
          <mat-form-field appearance="outline" fxFlex class="form-nopadd">
            <input matInput type="number" min="10" max="500" name="amount" [(ngModel)]="amount"
              placeholder="{{'rechargeComponent.maxmin' |translate}} " angulartics2On="click"
              angularticsAction="writeAmountOfRecharge"  angularticsCategory="rechargeCard">
              <mat-hint>{{"rechargeComponent.min" |translate }} - {{"rechargeComponent.max" |translate }}</mat-hint>

          </mat-form-field>

        </div>

      </div>

      <app-fulle-payments-methods-endorder [currMerchant]="currMerchant" [clientCards]="clientCards$"
        [currCard$]="currCard$" [clientCardLoader]="clientCardLoader"
        [rechargeMode]="true" [currPaymentChoice]="currPaymentChoice"
        (setPaymentChoiceEvent)="setPaymentChoice_($event)" (openCardMethodsDialEvent)="openCardMethodsDial($event)"
        (payMethodEvent)="payMethod($event)">
      </app-fulle-payments-methods-endorder>

      <!-- Boutton -->
      <div fxLayoutAlign="end center" fxHide.xs class="layout-padd">

        <button mat-raised-button color="primary" (click)="RechargeDial()" [disabled]="
        (!currCard$ && currSM &&currSM.payment_type && currSM.payment_type==='online' )
          || (!amount) || (amount && amount<10) || (amount && amount>500) || paiment_order_exist" angulartics2On="click" angularticsAction="RechargeDial" angularticsCategory="rechargeCard">
        {{"rechargeComponent.cardCredit" |translate }}
        </button>


      </div>

    </div>

  </div>

  <div fxLayoutAlign="center center" class="layout-padd" fxHide fxShow.xs>

    <button mat-raised-button color="primary" fxFlex (click)="RechargeDial()" [disabled]="
    (!currCard$ && currSM &&currSM.payment_type && currSM.payment_type==='online')
     || !amount || !payMethodvisible   || paiment_order_exist" angulartics2On="click" angularticsAction="RechargeDial" angularticsCategory="rechargeCard">
       {{"rechargeComponent.cardCredit" |translate }}
    </button>

  </div>

</div>

<app-popup-loader [flagLoading]="loader || success" [size]="30" [statusMessage]="statusMessage">
</app-popup-loader>
